import { render, staticRenderFns } from "./AdminRoutes.vue?vue&type=template&id=db474e26&scoped=true&"
import script from "./AdminRoutes.vue?vue&type=script&lang=js&"
export * from "./AdminRoutes.vue?vue&type=script&lang=js&"
import style0 from "./AdminRoutes.vue?vue&type=style&index=0&id=db474e26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db474e26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VDataTable,VDatePicker,VIcon})
